import { Button } from '@chakra-ui/react'
import React from 'react'

const Pagination = ({totalCount, handlePageChange, current_page}) => {
  return new Array(totalCount).fill(0).map((el,i)=>{
    const isActive = current_page === i + 1;
    return (
      <Button
        key={i}
        onClick={()=>handlePageChange(i+1)}
        colorScheme="purple"
        variant={isActive ? "solid" : "outline"}
        borderRadius="full"
        size="sm"
        mx={1}
      >
        {i+1}
      </Button>
    )
  })
}

export default Pagination
